import AddStudentDetails from "components/add-student-details/AddStudentDetails";
import { useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
export default function StudentStaffpage() {
  const [addStudent, setAddStudent] = useState(false)
  const [editStudent, setEditStudent] = useState(false)
  const [uploadStudent, setUploadStudent] = useState(false)
  return (
    <>
      
        <div className="camcont m-4" style={{ alignItems: "start" }}>
          <div style={{ display: "flex"  }}>
            <NavLink to="/admin/addstudent">
              <button style={{width:'200px'}}
               
                className="myBtn">
                <div>Student Face</div>
              </button>
            </NavLink>
            <NavLink to="/admin/addstaff">
              <button style={{width:'200px'}}
               
                className="myBtn">
                <div>Staff Face</div>
              </button>
            </NavLink>
        
            </div>
        </div>
    </>
  );
}



